var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.176,
    height: 13.175,
    viewBox: "0 0 11.176 13.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3437",
    "data-name": "Group 3437",
    transform: "translate(-6.407 -5.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3435",
    "data-name": "Group 3435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5253",
    "data-name": "Path 5253",
    d: "M17.29,5.71h0a1,1,0,0,0-1.41,0L12,9.58,8.11,5.7a1,1,0,0,0-1.41,0h0a1,1,0,0,0,0,1.41l4.59,4.59a1,1,0,0,0,1.41,0l4.59-4.59A.984.984,0,0,0,17.29,5.71Z",
    fill: "#323338"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5254",
    "data-name": "Path 5254",
    d: "M17.29,12.3h0a1,1,0,0,0-1.41,0L12,16.17,8.12,12.29a1,1,0,0,0-1.41,0h0a1,1,0,0,0,0,1.41l4.59,4.59a1,1,0,0,0,1.41,0L17.3,13.7A.993.993,0,0,0,17.29,12.3Z",
    fill: "#323338"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollIcon);
export default __webpack_public_path__ + "static/media/scrollIcon.7a9eb983fb371c6d46c681f767637fae.svg";
export { ForwardRef as ReactComponent };